module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10052.bc875047.jpg";